<template>
  <div class="text-block block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-audio-icon white--text text-lg-2" />
            </div>

            <h4>
              Audio 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">
<!--            <p>Allows to send an audio file in the chat. Supported formats: MP3, WAV, OGG. Maximum file size: ~20MB. If you use Dropbox, please replace "www" at the beginning of the audio file URL with "dl".-->
<!--            Example: https://dl.dropbox.com/s/sample.mp3</p>-->
            <label >Audio File URL</label>
            <!--                    <v-text-field-->
            <!--                            outline-->
            <!--                            v-model="data.url"-->
            <!--                            :error="!data.url || !common.validURL(data.url)"-->
            <!--                            :error-messages="!data.url? 'URL is Required':'' || !common.validURL(data.url)? 'URL is not valid':''"-->
            <!--                    >-->
            <!--                    </v-text-field>-->
            <vTextareaAutocomplete 
              v-model="data.url" 
              :type="'textfield'"
              :validation-rules="autocompleteAudioValidationRules"/>

            <image-input
              :url="data.url"
              @onImageUpload="updateImageUrl"
              type="audio"
              icon="botter-audio-icon"
            />
          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import imageInput from './common-inner-blocks/image-uploader-dropzone'
import FormValidation from '../FormValidation'
export default {
  name: 'CardAudio',
  components: {
    FormValidation,
    imageInput
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteAudioValidationRules: [v => !!v || 'Url is Required']
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {
    updateImageUrl(e) {
      this.data.url = e
    }
  }
}
</script>

<style scoped>
</style>
